import React from "react"

import SEO from "../components/SEO"
import Navigation from "../components/Navigation"


const AboutPage = () => {
    return (
        <>
            <SEO title="About"/>
            <Navigation />
        </>
    )
}

export default AboutPage
